import React from 'react';
import { Flower2Icon, GiftIcon, LibraryIcon, ListChecksIcon, ShoppingBagIcon, SunIcon } from 'lucide-react';
import { differentiators } from '../data/content';
import { Mark, SectionLead, SectionTitle } from './ui/Section';
const icons = {
  list: ListChecksIcon,
  bag: ShoppingBagIcon,
  sun: SunIcon,
  flower: Flower2Icon,
  gift: GiftIcon,
  library: LibraryIcon
};
export function Differentiators() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-58" data-mp="zdskvvwzlw0h">
      <div className="mx-auto max-w-5xl" data-id="element-59" data-mp="13ecj72tar5o7">
        <SectionTitle data-id="element-60" data-mp="13fdwldxsc493">
          More than patterns. <Mark data-id="element-61" data-mp="13g5pui3wtpw7">A whole collection of projects to enjoy.</Mark>
        </SectionTitle>
        <SectionLead data-id="element-62" data-mp="18c4b3wtxyrse">105 Designs. Different Styles. Complete Project Guidance.</SectionLead>

        <ul className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-63" data-mp="1ddtlda9cb1ff">
          {differentiators.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4" data-id="element-64" data-mp="2oq45ytdxjr8s">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blush-200" data-id="element-65" data-mp="bpc753hybrgf">
                  <Icon className="h-5 w-5 text-berry-700" aria-hidden="true" data-id="element-66" data-mp="7oa92pzrtlg1" />
                </span>
                <div data-id="element-67" data-mp="2n322t5gcqaf">
                  <h3 className="text-sm font-black uppercase leading-tight text-plum-950" data-id="element-68" data-mp="2mkyfbggn9sh">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-snug text-muted" data-id="element-69" data-mp="3tu77jjly84gq">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-sm font-black uppercase tracking-wide text-berry-700 md:text-base" data-id="element-70" data-mp="3k3kwm2p6g24d">
          A collection built around one simple idea: choose a design and enjoy making it.
        </p>
      </div>
    </section>;
}